import { c as _c } from "react/compiler-runtime";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import type { CollectedCard } from "@/entities/IProfile";
import { CollectedCollectionType } from "@/entities/IProfile";
import { formatNumberWithCommasOrDash } from "@/helpers/Helpers";
import { ContractType } from "@/types/enums";
import { faCheck, faMinusCircle, faPlus, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import Image from "next/image";
import { useId, useState } from "react";
import { Tooltip } from "react-tooltip";
import { COLLECTED_COLLECTIONS_META } from "../filters/user-page-collected-filters.helpers";
export default function UserPageCollectedCard(t0) {
  const $ = _c(89);
  const {
    card,
    contractType,
    showDataRow,
    interactiveMode: t1,
    selected: t2,
    onToggle,
    onIncQty,
    onDecQty,
    copiesMax,
    qtySelected: t3,
    isTransferLoading: t4,
    showZeroSeizedCount: t5
  } = t0;
  const interactiveMode = t1 === undefined ? "link" : t1;
  const selected = t2 === undefined ? false : t2;
  const qtySelected = t3 === undefined ? 0 : t3;
  const isTransferLoading = t4 === undefined ? false : t4;
  const showZeroSeizedCount = t5 === undefined ? false : t5;
  const collectionMeta = COLLECTED_COLLECTIONS_META[card.collection];
  const path = `${collectionMeta.cardPath}/${card.token_id}`;
  const tooltipId = useId();
  const isSelectMode = interactiveMode === "select";
  const canSelect = copiesMax > 0;
  const isSelectModeAndCanSelect = isSelectMode && canSelect;
  const isSelectable = !selected && canSelect;
  const isNotSelectable = !selected && !canSelect;
  const isSelectedAndCanSelect = canSelect && selected;
  const hasBalanceMismatch = isSelectMode && copiesMax !== (card.seized_count ?? 0);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsImageLoaded(true);
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const handleImageSettled = t6;
  const hasSeizedCountValue = card.seized_count !== null;
  const showSeizedCount = COLLECTED_COLLECTIONS_META[card.collection].dataRows.seizedCount && (showZeroSeizedCount ? hasSeizedCountValue : typeof card.seized_count === "number" && card.seized_count > 0);
  let t7;
  if ($[1] !== card.seized_count || $[2] !== copiesMax || $[3] !== isSelectMode) {
    t7 = () => {
      if (isSelectMode) {
        return formatNumberWithCommasOrDash(copiesMax);
      }
      return formatNumberWithCommasOrDash(card.seized_count ?? 0);
    };
    $[1] = card.seized_count;
    $[2] = copiesMax;
    $[3] = isSelectMode;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const getSeizedCountDisplay = t7;
  let t8;
  if ($[5] !== card.collection || $[6] !== card.tdh) {
    t8 = () => {
      if (card.collection === CollectedCollectionType.MEMELAB) {
        return "N/A";
      } else {
        return formatNumberWithCommasOrDash(+(card.tdh ?? 0).toFixed(0));
      }
    };
    $[5] = card.collection;
    $[6] = card.tdh;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const getTdhDisplay = t8;
  let t9;
  if ($[8] !== card.collection || $[9] !== card.rank || $[10] !== card.tdh) {
    t9 = () => {
      if (card.collection === CollectedCollectionType.MEMELAB) {
        return "N/A";
      } else {
        return card.tdh ? formatNumberWithCommasOrDash(card.rank ?? 0) : "-";
      }
    };
    $[8] = card.collection;
    $[9] = card.rank;
    $[10] = card.tdh;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const getRankDisplay = t9;
  let t10;
  if ($[12] !== contractType || $[13] !== copiesMax || $[14] !== isNotSelectable || $[15] !== isSelectMode || $[16] !== isSelectable || $[17] !== isSelectedAndCanSelect || $[18] !== isTransferLoading || $[19] !== onDecQty || $[20] !== onIncQty || $[21] !== onToggle || $[22] !== qtySelected) {
    t10 = isSelectMode ? <div className={["tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10", "tw-flex tw-items-start tw-justify-end", "tw-p-2"].join(" ")}>{isNotSelectable && <div className="tw-pointer-events-auto tw-absolute tw-inset-0 tw-flex tw-items-start tw-justify-center tw-p-2"><div className="tw-rounded-md tw-bg-iron-900/95 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-iron-300 tw-opacity-75 tw-ring-1 tw-ring-white/20 tw-transition-opacity tw-duration-200 group-hover:tw-opacity-100">{isTransferLoading ? <div className="tw-flex tw-items-center tw-gap-1"><span>Loading</span><CircleLoader size={CircleLoaderSize.SMALL} /></div> : "Not owned by your connected wallet"}</div></div>}{isSelectable && <button type="button" aria-label="Select" onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }} className={["tw-pointer-events-auto tw-flex tw-border-none", "tw-items-center tw-justify-center", "tw-h-9 tw-w-9 tw-rounded-full", "tw-bg-iron-900/90 hover:tw-bg-primary-500/75", "tw-ring-1 tw-ring-white/30"].join(" ")}><FontAwesomeIcon icon={faPlus} className="tw-size-5" color="#fff" /></button>}{isSelectedAndCanSelect && <div className="tw-pointer-events-auto tw-flex tw-items-center tw-gap-2">{contractType === ContractType.ERC1155 ? <div className={["tw-flex tw-items-center tw-justify-center tw-gap-1.5", "tw-rounded-full tw-bg-primary-500 tw-p-2 tw-backdrop-blur", "tw-mt-[2px] tw-font-medium"].join(" ")}><button type="button" onClick={e_0 => {
            e_0.preventDefault();
            e_0.stopPropagation();
            if (qtySelected <= 1) {
              onDecQty();
              onToggle();
            } else {
              onDecQty();
            }
          }} aria-label="Decrease quantity" className="tw-flex tw-items-center tw-border-none tw-bg-transparent tw-p-0 focus:tw-outline-none"><FontAwesomeIcon icon={faMinusCircle} className="tw-size-5" color="#fff" /></button><div className="tw-min-w-[2ch] tw-text-center tw-text-sm tw-tabular-nums tw-text-white">{qtySelected}/{copiesMax}</div><button type="button" onClick={e_1 => {
            e_1.preventDefault();
            e_1.stopPropagation();
            if (qtySelected < copiesMax) {
              onIncQty();
            }
          }} disabled={qtySelected >= copiesMax} aria-label="Increase quantity" className="tw-flex tw-items-center tw-border-none tw-bg-transparent tw-p-0 focus:tw-outline-none disabled:tw-opacity-50"><FontAwesomeIcon icon={faPlusCircle} className="tw-size-5" color="#fff" /></button></div> : <button type="button" aria-label="Deselect" onClick={e_2 => {
          e_2.preventDefault();
          e_2.stopPropagation();
          onToggle();
        }} className={["tw-flex tw-items-center tw-justify-center", "tw-h-9 tw-w-9 tw-rounded-full tw-bg-primary-500 hover:tw-bg-primary-600", "tw-ring-1 tw-ring-white/30"].join(" ")}><FontAwesomeIcon icon={faCheck} className="tw-size-5" /></button>}</div>}</div> : null;
    $[12] = contractType;
    $[13] = copiesMax;
    $[14] = isNotSelectable;
    $[15] = isSelectMode;
    $[16] = isSelectable;
    $[17] = isSelectedAndCanSelect;
    $[18] = isTransferLoading;
    $[19] = onDecQty;
    $[20] = onIncQty;
    $[21] = onToggle;
    $[22] = qtySelected;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const OverlayControls = t10;
  const isDisabled = isSelectMode && !canSelect;
  let t11;
  if ($[24] !== isDisabled || $[25] !== selected) {
    t11 = () => {
      if (selected) {
        return "tw-ring-2 tw-ring-primary-500 tw-ring-inset";
      }
      if (isDisabled) {
        return "tw-opacity-60";
      }
      return "";
    };
    $[24] = isDisabled;
    $[25] = selected;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const getRingClasses = t11;
  let t12;
  if ($[27] !== isDisabled || $[28] !== isSelectModeAndCanSelect) {
    t12 = () => {
      if (isSelectModeAndCanSelect) {
        return "tw-cursor-pointer";
      }
      if (isDisabled) {
        return "tw-cursor-not-allowed";
      }
      return "";
    };
    $[27] = isDisabled;
    $[28] = isSelectModeAndCanSelect;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const getCursorClasses = t12;
  let t13;
  if ($[30] !== isSelectModeAndCanSelect || $[31] !== onToggle || $[32] !== selected) {
    t13 = e_3 => {
      if (isSelectModeAndCanSelect && !selected) {
        e_3.preventDefault();
        onToggle();
      }
    };
    $[30] = isSelectModeAndCanSelect;
    $[31] = onToggle;
    $[32] = selected;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const handleCardClick = t13;
  let t14;
  if ($[34] !== isSelectModeAndCanSelect || $[35] !== onToggle || $[36] !== selected) {
    t14 = e_4 => {
      if (isSelectModeAndCanSelect && !selected && (e_4.key === "Enter" || e_4.key === " ")) {
        e_4.preventDefault();
        onToggle();
      }
    };
    $[34] = isSelectModeAndCanSelect;
    $[35] = onToggle;
    $[36] = selected;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const handleCardKeyDown = t14;
  let t15;
  if ($[38] !== handleCardClick || $[39] !== handleCardKeyDown || $[40] !== isSelectModeAndCanSelect || $[41] !== selected) {
    t15 = isSelectModeAndCanSelect && !selected ? {
      role: "button",
      tabIndex: 0,
      "aria-label": "Select NFT for transfer",
      onClick: handleCardClick,
      onKeyDown: handleCardKeyDown
    } : {};
    $[38] = handleCardClick;
    $[39] = handleCardKeyDown;
    $[40] = isSelectModeAndCanSelect;
    $[41] = selected;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const t16 = getRingClasses();
  const t17 = getCursorClasses();
  let t18;
  if ($[43] !== t16 || $[44] !== t17) {
    t18 = ["tw-group tw-relative", "tw-flex tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.02] tw-shadow-xl tw-transition-all tw-duration-300 hover:tw-border-white/30", t16, t17].filter(Boolean);
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  const t19 = t18.join(" ");
  let t20;
  if ($[46] !== isImageLoaded) {
    t20 = !isImageLoaded && <div className="tw-absolute tw-inset-0 tw-animate-pulse tw-bg-iron-800" />;
    $[46] = isImageLoaded;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  const t21 = card.token_name || collectionMeta.label;
  const t22 = `tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain ${!isImageLoaded ? "tw-opacity-0" : "tw-opacity-100"} tw-transition-opacity tw-duration-300`;
  let t23;
  if ($[48] !== card.img || $[49] !== t21 || $[50] !== t22) {
    t23 = <Image unoptimized={true} src={card.img} alt={t21} width={800} height={800} sizes="(max-width: 640px) 100vw, 33vw" onLoad={handleImageSettled} onError={handleImageSettled} className={t22} />;
    $[48] = card.img;
    $[49] = t21;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t20 || $[53] !== t23) {
    t24 = <div className="tw-relative tw-flex tw-aspect-square tw-items-center tw-justify-center tw-overflow-hidden tw-bg-white/[0.02]">{t20}{t23}</div>;
    $[52] = t20;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== collectionMeta.label) {
    t25 = <span className="tw-mr-2 tw-truncate tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-white/40">{collectionMeta.label}</span>;
    $[55] = collectionMeta.label;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== card.token_id) {
    t26 = <span className="tw-font-mono tw-text-[11px] tw-font-medium tw-text-white/50">#{card.token_id}</span>;
    $[57] = card.token_id;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== t25 || $[60] !== t26) {
    t27 = <div className="tw-flex tw-items-center tw-justify-between">{t25}{t26}</div>;
    $[59] = t25;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== card.token_name) {
    t28 = <h3 className="tw-m-0 tw-line-clamp-1 tw-text-[14px] tw-font-semibold tw-leading-snug tw-text-white/90 tw-transition-colors group-hover:tw-text-white">{card.token_name}</h3>;
    $[62] = card.token_name;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== getSeizedCountDisplay || $[65] !== hasBalanceMismatch || $[66] !== showSeizedCount || $[67] !== tooltipId) {
    t29 = showSeizedCount && <span className="tw-flex tw-items-center tw-gap-0.5 tw-whitespace-nowrap tw-text-[11px] tw-font-medium tw-text-white/50">{getSeizedCountDisplay()}x{hasBalanceMismatch && <><span className="tw-cursor-help tw-text-primary-400" data-tooltip-id={tooltipId}>*</span><Tooltip id={tooltipId} variant="light" className="tw-z-[9999]" style={{
          padding: "6px 10px",
          fontSize: "12px",
          maxWidth: "85%",
          whiteSpace: "normal",
          wordWrap: "break-word"
        }}>Only the balance of the connected wallet is available for transfer</Tooltip></>}</span>;
    $[64] = getSeizedCountDisplay;
    $[65] = hasBalanceMismatch;
    $[66] = showSeizedCount;
    $[67] = tooltipId;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== t28 || $[70] !== t29) {
    t30 = <div className="tw-flex tw-justify-between tw-gap-x-2">{t28}{t29}</div>;
    $[69] = t28;
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== getRankDisplay || $[73] !== getTdhDisplay || $[74] !== showDataRow) {
    t31 = showDataRow && <div className="tw-mt-2 tw-flex tw-items-center tw-justify-between tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/[0.08] tw-pt-2.5"><div className="tw-flex tw-items-baseline tw-gap-1.5"><span className="tw-text-[13px] tw-font-semibold tw-text-white/80">{getTdhDisplay()}</span><span className="tw-text-[13px] tw-font-semibold tw-text-white/30">TDH</span></div><span className="tw-rounded-md tw-bg-white/[0.05] tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-medium tw-text-white/60">Rank {getRankDisplay()}</span></div>;
    $[72] = getRankDisplay;
    $[73] = getTdhDisplay;
    $[74] = showDataRow;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== t27 || $[77] !== t30 || $[78] !== t31) {
    t32 = <div className="tw-flex tw-flex-col tw-gap-1.5 tw-p-4">{t27}{t30}{t31}</div>;
    $[76] = t27;
    $[77] = t30;
    $[78] = t31;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== OverlayControls || $[81] !== t15 || $[82] !== t19 || $[83] !== t24 || $[84] !== t32) {
    t33 = <div {...t15} className={t19}>{OverlayControls}{t24}{t32}</div>;
    $[80] = OverlayControls;
    $[81] = t15;
    $[82] = t19;
    $[83] = t24;
    $[84] = t32;
    $[85] = t33;
  } else {
    t33 = $[85];
  }
  const CardBody = t33;
  if (isSelectMode) {
    return CardBody;
  }
  let t34;
  if ($[86] !== CardBody || $[87] !== path) {
    t34 = <Link href={path} className="tw-no-underline">{CardBody}</Link>;
    $[86] = CardBody;
    $[87] = path;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  return t34;
}